import React from 'react';
import { Link } from 'react-router-dom';

import geox01 from '../../assets/imgs/geoxITC/geoxITC_01.jpg'; 
import geox02 from '../../assets/imgs/geoxITC/geoxITC_02.jpg'; 
import geox03 from '../../assets/imgs/geoxITC/geoxITC_03.jpg'; 

import vayyar from '../../assets/imgs/vayyar/cover-img.png'; 


const GeoxITCPage = () => {


  return (
    <div className='bg-light'>
      <div className='header-height'></div>
      <div className='row'>
        <div className='col-sm-2 col-xs-12'></div>
        <div className='col-sm col-xs-12'>
        <div className='row px-3 py-5 px-sm-5'>
          <div className='col-md-6 col-xs-12 text-start mb-5'>
              <p className='fs-2 fw-normal lh-sm capitalize mb-2'>Geox Analytics</p>
                <p className='fs-1rem fw-light capitalize'>
                  Animated Data Visualization
                    </p>
              <p className='mt-3 fw-200'>2024</p>
            </div>
            <div className='col-md col-xs-12  mb-5'>
              <p className='fw-300 fs-5'>
              This animated silent short film was created for Geox Analytics to showcase the depth and accuracy of their property data collection across the USA. Designed for both website integration and booth display at ITC 2024, the video visually demonstrates how Geox’s advanced analytics provide insurers and risk assessors with critical property insights. 
              </p>
            </div>
            
            <div className='col-xs-12'>
            <div className='mb-sm-5'></div>

              <video width="100%" height="auto" autoPlay muted loop>
                  <source src="https://d4eb9hkrm2864.cloudfront.net/portfolio/geox-hero.mp4" type="video/mp4" />
                </video>
            </div>

          </div>
        </div>
      </div>

      <div className='row px-3 py-5'>
      <div className='col-sm-6 col-xs-12 px-2 px-sm-5 py-sm-5 py-2'>
      <p className='fs-5'>
          The animation features 3D environment, portraying a geographic location with various properties. Through seamless transitions, the focus shifts to specific properties, unveiling layers of data analytics that highlight key risk factors, structural details, and other critical insights. The clean, modern design ensures clarity, making the data easy to understand and engaging for viewers.
          </p>
        </div>
        <div className='col-sm-6 col-xs-12 '>

        </div>
      </div>

      {/* <div className='row p-0'>
        <img className='py-2' src={geox01} width='100%' alt='geox data analytics animation asset'/>
      </div> */}


      {/* <div className='row my-5'>
        <div className='col-sm-6 col-xs-12'></div>
        <div className='col-sm-6 col-xs-12 p-5'>
          <p className='fs-5'>
          Presenting data through visuals makes it more accessible, engaging, and memorable. By leveraging animation, users can visually experience the impact of Geox’s technology in real-time, transforming complex analytics into clear, intuitive insights.
            </p>
          <br></br>
          <p className='fs-5'>
          Integrating this animated content into Geox Analytics' official website and digital platforms enhances user engagement and brand recognition. This approach not only strengthens Geox’s visual identity but also reinforces its position as a leader in AI-powered property intelligence for the insurance and risk assessment industry.
          </p>
        </div>
      </div> */}


      <div className='row mx-0 mt-5 px-2 px-sm-5'>
        <div className='col-sm-6 col-xs-12'>
          <img className='py-2' src={geox01} width='100%' alt='geox data analytics animation asset'/>
        </div>
        <div className='col-sm-6 col-xs-12'>
          <img className='py-2' src={geox02} width='100%' alt='geox data analytics animation asset'/>
        </div>
        <div className='col-sm-6 col-xs-12'>
          {/* <img className='py-2' src={geox03} width='100%'/> */}
        </div>
        <div className='col-sm-6 col-xs-12'>
          <img className='py-2' src={geox03} width='100%' alt='geox data analytics animation asset'/>
        </div>
      </div>



      <div className='row g-4 p-5 m-0'>
      <div className='col-md'></div>
        <div className='col-md-6'>

        </div>
      </div>

      <div className='row py-5 px-3 px-sm-5'>
        <div className='col-sm-2 col-xs-12'></div>
            <div className='col-sm col-xs-12'>
          <div className='py-2'>
            <Link to={"http://geoxanalytics.com"}>
              <a className='d-inline-flex align-items-center fs-5 fw-bold text-dark'>
                <h5 className='fs-18 fw-600'>Client: Geox Analytics</h5>
                <div className='arrow-out'></div>
              </a>
            </Link>
          </div>

          <div className='py-2'></div>
          <div className='d-block'>
          </div>

          <div className='py-2'></div>

          <div className='row'>
          <div className='col-sm col-xs-12'>
              <h5 className='fs-18 fw-600'>Capabilities</h5>
              <ul className='p-0'>
                <li className='py-1'>3D Modling</li>
                <li className='py-1'>3D Animation</li>
                <li className='py-1'>Movie</li>
                <li className='py-1'>Booth Design</li>
              </ul>
            </div>
            <div className='col-sm col-xs-12'>
            <h5 className='fs-18 fw-600'>Softwares</h5>
              <ul className='p-0'>
                <li className='py-1'>Maya</li>
                <li className='py-1'>Substance Painter</li>
                <li className='py-1'>After Effects</li>
                <li className='py-1'>Photosop</li>
              </ul>
            </div>
            <div className='col-sm col-xs-12'>
            <h5 className='fs-18 fw-600'>Cooperation</h5>
              <ul className='p-0'>
                <li className='py-1'>Project</li>
              </ul>
            </div>
            <div className='col-sm col-xs-12'>
            <h5 className='fw-600'>Industry</h5>
              <li className='py-1'>Technology</li>
              <h5 className='fw-600 pt-2'>Duration</h5>
              <li className='py-1'>1 Months</li>
            </div>
          </div>
        </div>
      </div>

      <div className='row mx-0 mt-3 mt-sm-5'>
      <div className='col-sm-12 col-xs-12 text-end p-5'>
          <Link to={"/vayyar"}>
            <a className='fs-5 fw-bold text-dark'>
              Next work 
              <div className='arrow-right'></div>
            </a>
          </Link>
        </div>
        <div className='col-sm-2 col-xs-12 p-3 p-sm-5'></div>
        <div className='col-sm col-xs-12 p-0'>
          <Link to={"/vayyar"}>
            <div className='image-box-300'>
              <img src={vayyar} alt="vayyar next" />
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default GeoxITCPage;
